import { render } from "./resultitem.vue?vue&type=template&id=8d48c7d6&scoped=true&ts=true"
import script from "./resultitem.vue?vue&type=script&lang=ts"
export * from "./resultitem.vue?vue&type=script&lang=ts"

import "./resultitem.vue?vue&type=style&index=0&id=8d48c7d6&lang=less"
import "./resultitem.vue?vue&type=style&index=1&id=8d48c7d6&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d48c7d6"]])

export default __exports__